import {variables} from '../Variables.js';
import axiosService from './axios';


export function getMonths(data) {
    if (!data || typeof data !== 'object') {
        console.warn('Invalid data provided');
        return {};
    }

    const monthKeyMap = {
        'January': 1,
        'February': 2,
        'March': 3,
        'April': 4,
        'May': 5,
        'June': 6,
        'July': 7,
        'August': 8,
        'September': 9,
        'October': 10,
        'November': 11,
        'December': 12
    };

    return Object.entries(data)
        .filter(([_, monthData]) => monthData.value !== "")
        .map(([monthName, _]) => ({
            name: monthName,
            key: monthKeyMap[monthName]
        }));
}

export function getMonthsWithValues(data) {
    if (!data || typeof data !== 'object') {
        console.warn('Invalid data provided');
        return {};
    }
    return Object.entries(data)
        .filter(([_, monthData]) => monthData.value !== "")
        .reduce((acc, [month, monthData]) => ({
            ...acc,
            [month]: monthData.value
        }), {});
}


export function getMonthsWithChecks(data) {
    if (!data || typeof data !== 'object') {
        console.warn('Invalid data provided');
        return {};
    }
    
    return Object.entries(data)
        .filter(([_, monthData]) => monthData.value !== "")
        .reduce((acc, [month, monthData]) => ({
            ...acc,
            [month]: monthData.check
        }), {});
}

  export const refreshMaterializedView = (view_names)=>{
    axiosService.post('/refresh_materialized_view/', {
      view_names
    })
    .then(result => {
      alert('Data updated');
      window.location.reload();
    })
    .catch(error => {
      alert('Failed: ' + (error?.response?.data?.error || error?.message || 'Unknown error'));
    });
  }